import { tv } from '@/common/theme/tv.config';
import { bgVariants } from '@/common/theme/variants';

export const styles = {
  root: tv({
    base: 'h-[1rem] w-full overflow-hidden rounded-xs',
    variants: {
      backgroundColor: bgVariants,
    },
    defaultVariants: {
      backgroundColor: 'neutral30',
    },
  }),
  bar: tv({
    base: 'h-full',
    variants: {
      backgroundColor: bgVariants,
    },
  }),
};
